// extracted by mini-css-extract-plugin
export default {"search":"search_search__pXqfq","searchContainer":"search_searchContainer__S-o5c","searchIcon":"search_searchIcon__1PUjz"};